import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  dictionariesRequest: ['name', 'query'],
  dictionariesSuccess: ['name', 'data'],
  dictionariesFailure: ['name', 'error'],
});

export const DictionariesTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  andOr: {
    data: [
      {name: 'И', id: 'and'},
      {name: 'ИЛИ', id: 'or'},
    ],
    error: null,
    fetching: false,
  },
  regions: {
    data: null,
    error: null,
    fetching: false,
  },
  systemTypes: {
    data: null,
    error: null,
    fetching: false,
  },
  mailingStatuses: {
    data: null,
    error: null,
    fetching: false,
  },
  mailingTypes: {
    data: null,
    error: null,
    fetching: false,
  },
  userRoles: {
    data: null,
    error: null,
    fetching: false,
  },
  companies: {
    data: null,
    error: null,
    fetching: false,
  },
  fields: {
    data: null,
    error: null,
    fetching: false,
  },
  applicabilities: {
    data: null,
    error: null,
    fetching: false,
  },
  fotafields: {
    data: null,
    error: null,
    fetching: false,
  },
  operators: {
    data: null,
    error: null,
    fetching: false,
  },
  genders: {
    data: null,
    error: null,
    fetching: false,
  },
  campaignStatuses: {
    data: null,
    error: null,
    fetching: false,
  },
  campaigns: {
    data: null,
    error: null,
    fetching: false,
  },
  firmwareVersions: {
    data: null,
    error: null,
    fetching: false,
  },
  firmwareStatuses: {
    data: null,
    error: null,
    fetching: false,
  },
  firmwares: {
    data: null,
    error: null,
    fetching: false,
  },
  applicabilities: {
    data: null,
    error: null,
    fetching: false,
  },
  TOTasks: {
    data: null,/*[
    //['id', 'groupTitle', 'title', 'TO-0', 'TO-1', 'TO-2', 'ТО-3', 'TO-4', 'TO-5', 'ТО-6'],
      [0, 'Двигатель', 'Ремень привода газораспределительного механизма', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [1, 'Двигатель', 'Ремень привода генератора', 'П', 'П', 'П', 'П', 'П', 'П', 'З'],
      [2, 'Двигатель', 'Масло в двигателе и масляный фильтр', 'П', 'З', 'З', 'З', 'З', 'З', 'З'],
      [3, 'Двигатель', 'Шланги и соединения системы охлаждения', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [4, 'Двигатель', 'Система охлаждения', 'П', 'П', 'П', 'П', 'П', 'П', 'З'],
      [5, 'Двигатель', 'Топливный фильтр', 'П', 'П', 'З', 'П', 'З', 'П', 'З'],
      [6, 'Двигатель', 'Фильтрующий элемент воздушного фильтра', 'П', 'П', 'З', 'П', 'З', 'П', 'З'],
      [7, 'Двигатель', 'Свечи зажигания', 'П', 'П', 'З', 'П', 'З', 'П', 'З'],
      [8, 'Двигатель', 'Высоковольтные провода', 'П', 'П', 'П', 'П', 'П', 'П', 'З'],
      [9, 'Двигатель', 'Тепловые зазоры в приводе клапанов', null, 'П', null, 'П', null, 'П', null],
      [10, 'Двигатель', 'Прокладка клапанной крышки, регулировочные шайбы клапанов ', 'П', 'П', null, 'П', null, 'П', null],
      [11, 'Трансмиссия', 'Механическая коробка передач', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [12, 'Трансмиссия', 'Автоматическая коробка передач', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [13, 'Трансмиссия', 'Пыльники (чехлы) шарниров равных угловых скоростей', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [14, 'Ходовая часть', 'Передняя подвеска', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [15, 'Ходовая часть', 'Задняя подвеска', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [16, 'Ходовая часть', 'Колеса и шины', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [17, 'Ходовая часть', 'Углы установки колес', 'П', null, 'П', null, 'П', null, 'П'],
      [18, 'Рулевое управление', 'Рулевой привод, пыльники (защитные чехлы)', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [19, 'Тормозная система', 'Гидропривод тормозной системы (замена тормозной жидкости)', 'П', 'П', 'П', 'П', 'П', 'П', 'З'],
      [20, 'Тормозная система', 'Тормозные механизмы (замена передних, задних колодок)', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [21, 'Тормозная система', 'Стояночный тормоз', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [22, 'Тормозная система', 'Трубопроводы гидропривода тормозов', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [21, 'Электрооборудование', 'Фары головного света', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [22, 'Электрооборудование', 'Аккумуляторная батарея', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [23, 'Электрооборудование', 'Внешние осветительные приборы', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [24, 'Кузов', 'Воздушный фильтр системы отопления (кондиционирования) и вентиляции салона', 'З', 'З', 'З', 'З', 'З', 'З', 'З'],
      [25, 'Кузов', 'Ремни безопасности, замки и узлы крепления к кузову', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [26, 'Кузов', 'Замки, петли, защелка капота, арматура кузова', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
      [27, 'Кузов', 'Прочистка дренажных отверстий', 'П', 'П', 'П', 'П', 'П', 'П', 'П'],
    ],*/
    error: null,
    fetching: false,
  },
  TOTaskTypes: {
    data: [
      {
        id: '-',
        name: '-',
      },
      {
        id: 'П',
        name: 'Проверка',
      },
      {
        id: 'З',
        name: 'Замена',
      }
    ],
    error: null,
    fetching: false,
  },
  tariffTypes: {
    data: null,
    error: null,
    fetching: false,
  },
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = (state, {name}) => state.merge({[name]:{error: null, fetching: true}});

// we've successfully ...
export const success = (state, {name, data}) => 
  state.merge({[name]:{data, error: null, fetching: false}});
// we've had a problem ...
export const failure = (state, {name, error}) =>
  state.merge({[name]:{error, fetching: false}});

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DICTIONARIES_REQUEST]: request,
  [Types.DICTIONARIES_SUCCESS]: success,
  [Types.DICTIONARIES_FAILURE]: failure,
});